import React, {useEffect, useState} from 'react';
import style from "./REG300F1.module.scss";
import styleCom from "./REGCOM.module.scss";
import SwitchGroup from "components/Button/SwitchGroup"
import InputUnitText from "components/InputText/InputUnitText";
import Table from "components/Table/Table";
import DatePicker from "components/DatePicker/DatePicker";
import {ymdToDate} from './REGComUtil';
import Button from "../../components/Button/Button";
import toast from "../../components/Toast/Toast";
import {postData} from "../../utils/TransactionUtil"; //


const REG300F2 = (props) => {

    let htmlTab0=<></>;  let htmlTab1=<></>;  let htmlTab2=<></>;

    const [isStudyPid, setIsStudyPid] = useState(false);
    const [isRandIndex  , setIsRandIndex]   = useState();

    //폼 로드시
    useEffect(() => {

        if(    props.getMstValue('studyPid') !== null
            && props.getMstValue('studyPid') !== ''
            && props.getMstValue('studyPid') !== undefined
            && props.getMstValue('studyPid').length === 8
        ){
            setIsStudyPid(true);
        }else{
            setIsStudyPid(false);
        }

        if(    props.getMstValue('randIndex') !== null
            && props.getMstValue('randIndex') !== ''
            && props.getMstValue('randIndex') !== undefined
        ){
            setIsRandIndex(true);
        }else{
            setIsRandIndex(false);
        }
    }, [props.getMstValue('studyPid'), props.getMstValue('randIndex')]);
    

    /* Event ****************************************************************************** */
        const onClick_randomize = async (e) => {
            if (await randomizeValidate()) {
                if (window.confirm("무작위군 작업을 수행하시겠습니까?")) {

                    svcUpdateRandom().then(() => {
                        //toast({ type: 'info', message: '저장되었습니다.', opt: { position: "top-center"} });
                    });
                }
            }

        }

    const onClick_pidClear = async (e) => {
        props.setMstValue("studyPid", "");  //입력 상태에서만 초기화
    }


    /* User function ==========================================================================================*/

    const randomizeValidate = async () => {
        let valid = false;

        if (   props.getMstValue('studyPid') === null
            || props.getMstValue('studyPid').trim() === ''
            || props.getMstValue('studyPid') === undefined
            || props.getMstValue('studyPid').length !== 8) {
            valid = false;
            toast({type: 'info', message: "연구 등록번호를 확인하여 주십시오."});
        }
        else if (await svcReadyCaseCheck() === false) {
            props.setMstValue("studyPid", "");
            valid = false;
            toast({type: 'warning', message: "무작위군 정보를 확인하여 주십시오."});
        }else{
            valid = true;
        }


        return  valid;
    };


    /* Call Service ==========================================================================================*/

    const svcReadyCaseCheck = async() => {
        //연구등록번호 체크
        let chkValue = false;
        const param ={ hsptCd: props.getMstValue("hsptCd") , studyPid : props.getMstValue("studyPid") };
        let result = await postData("/RED/readyCaseCheck", param);

        if(result.regChkYn==='Y'){
            chkValue = true;
        }else{
            chkValue = false;
            if(result.randCnt < 1){
                toast({type: 'info', message: "무작위군 정보를 찾을 수 없습니다."});
            }else if(result.workCnt > 0){
                toast({type: 'info', message: "이미 등록된 연구번호입니다."});
            }
        }
        return chkValue;

    }

    async function svcUpdateRandom() {

        const param = {
            mstId: props.getMstValue("mstId"), hsptCd: props.getMstValue("hsptCd") , studyPid : props.getMstValue("studyPid")
        };

        let result = await postData("/RED/updateRandomize", param);
        props.setMstValue("studyPid",result[0].studyPid);
        props.setMstValue("randIndex",result[0].randIndex);
        props.setMstValue("randIndexNm",result[0].randIndexNm);

    }


    htmlTab0 =
        <>
            <div className={styleCom.title_wrap}>
                <h3></h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop:"10px", padding:"20px"}}>
                <Table variant='default' rowCnt={5} colSize={['25%', '25%', '25%', '25%']} rowSize={'56px'}>
                    <div>등록기관</div>
                    <div><InputUnitText type={"text"} value={props.getMstValue('hsptNm')}
                                        unit={""} readOnly={true}/></div>
                    <div>Study ID</div>
                    <div>
                        <InputUnitText type={"text"} value={props.getMstValue('studyId')}
                                       unit={""} readOnly={true}/></div>
                    <div>대상자 영문 이니셜</div>
                    <div><InputUnitText type={"text"} value={props.getMstValue('initial')}
                                        unit={""} readOnly={true}/></div>
                    <div>연령(만)</div>
                    <div><InputUnitText type={"text"} value={props.getMstValue('age')}
                                        unit={"세"} readOnly={true}
                    /></div>

                    <div>Enroll Date</div>
                    <DatePicker selDate={ymdToDate(props.getMstValue('enrollDt'))}
                                dateFormat={'yyyy-MM-dd'} isDisabled={true}
                    />
                    <div>동의서 취득일</div>
                    <DatePicker selDate={ymdToDate(props.getMstValue('acquisitionDt'))}
                                dateFormat={'yyyy-MM-dd'} isDisabled={true}
                    />
                    <div>연구 등록번호</div>
                    <div>
                        <InputUnitText type={"text"} value={props.getMstValue('studyPid')}
                                       unit={""}  readOnly={isStudyPid} width={"120px"}
                                       onChange={(value) => props.setMstValue("studyPid", value)}/>

                        <Button variant="Quaternary" size="md" addStyle={{width: "60px", height: "40px"}}
                                onClick={() => onClick_pidClear()} disabled={isRandIndex}>
                            Clear
                        </Button>
                        <Button variant="Secondary" size="md" addStyle={{width: "100px", height: "40px"}}
                                onClick={() => onClick_randomize()} disabled={isRandIndex}>
                            Randomize
                        </Button>

                    </div>
                    <div>성별</div>
                    <div>
                        <SwitchGroup value={props.getMstValue("sex")}
                                     items={{"남성": "M", "여성": "F"}} isDisabled={true}/>
                    </div>
                    <div>배정군</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"text"} value={props.getMstValue('randIndexNm')}
                                       unit={""} readOnly={true}/>
                    </div>


                </Table>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>

                <h3>선정/제외 기준평가</h3>
                <Table variant='Vertical' rowCnt={12} colSize={['75%', '25%']} rowSize={'56px'}>
                    <div className={style.cellTyp1}>상기 시험 대상자는 선정/제외 기주을 만족하고, 관찰연구 참여에 적합합니까?</div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("eligibleYn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={"col_merge"}
                         style={{justifyContent: 'left', backgroundColor: "#FAFAFA"}}>
                        <span className={style.cellHeader}>Inclusion Criteria</span>
                    </div>

                    <div className={style.cellTyp1}>1. 만 19 세 이상의 성인</div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("include1Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>2. 진료실 수축기 혈압 ≥ 140 mmHg 또는 이완기혈압 ≥ 90 mmHg
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("include2Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>3. 새로이 혈압약을 복용하거나 기존 혈압약을 조절해야할 것으로 예상되는 환자</div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("include3Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>4. 연구 참여에 서면 동의하고, 연구기간 동안 꾸준히 내원 및 추적관찰이 가능한 환자</div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("include4Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>

                    <div className={"col_merge"}
                         style={{justifyContent: 'left', backgroundColor: "#FAFAFA"}}>
                        <span className={style.cellHeader}>Exclusion Criteria</span>
                    </div>
                    <div className={style.cellTyp1}>
                        1. Olmesartan, amlodipine, hydrochlorothiazide 등 본 연구에서 사용 예정인 주요 약제에 대한 부작용 기왕력이 있는 환자
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("exclude1Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>
                        2. 이차성 고혈압이 의심되는 환자
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("exclude2Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>
                        3. 심방세동이 있는 환자
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("exclude3Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>
                        4. 임신 중이거나 수유 중인 여성
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("exclude4Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>
                        5. 기타 심각한 내과적 질환 등으로 연구 참여가 어렵거나 연구 수행에 지장이 있을 수 있는 환자
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("exclude5Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>

                </Table>
            </div>
        </>;


    let renderHtml =
        <></>
    ;

    if (props.contentId === "T0") {
        renderHtml = htmlTab0;
    } else {
        renderHtml = <>준비중 입니다.</>;
    }
    return (
        <>
            {renderHtml}
        </>
    );

};

export default REG300F2;

